import { wheramiService } from '../services';

import { WhereamiServiceResponse } from './types';

const localeMap: { [key: string]: string } = {
  'zh-hans': 'zh-Hans',
  'zh-hant': 'zh-Hant',
  en: 'en-GB',
  en_us: 'en',
};

export const getWhereami = async ({ locale }: { locale: string }) => {
  const mappedLocale = localeMap[locale] || locale;
  return wheramiService.get<WhereamiServiceResponse>({ path: '', params: { locale: mappedLocale } })
    .request;
};
